// extracted by mini-css-extract-plugin
export default {"component":"Brand_component__4rGMY","componentContainer":"Brand_componentContainer__tjzV9","saveBtn":"Brand_saveBtn__OH5x7","header":"Brand_header__ghLnx"};